import { BackupType } from '@lib/core/enum';
import { BaseDevice } from '@lib/core/model';
import { Uuid } from '@lib/core/type';
import { WorkerItem } from '@proget-shared/grid/grid-actions';
import { SelectableItem } from '@proget-shared/grid/selection';

export class DeviceBackup implements SelectableItem, WorkerItem {
  constructor(
    public readonly id: Uuid,
    public readonly finished: boolean,
    public readonly executionType: string,
    public readonly createdAt: string,
    public readonly expiresAt: string,
    public readonly rangeTo: string,
    public readonly type: BackupType,
    public readonly device: BaseDevice
  ) {}

  getId(): Uuid {
    return this.id;
  }

  getDisplayName(): string {
    return this.createdAt || this.getRangeTo();
  }

  getSelectionId(): Uuid {
    return this.id;
  }

  public getDate(): string {
    return `${this.createdAt}${this.getRangeTo()}`;
  }

  public get isSnapshot(): boolean {
    return this.type === BackupType.SNAPSHOT;
  }

  private getRangeTo(): string {
    return this.rangeTo && this.rangeTo !== this.createdAt ? ` - ${this.rangeTo}` : '';
  }
}
